import React from 'react';
import { alpha, Button } from '@mui/material';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { SEARCE_COLORS } from '../../theme';

export interface TableCsvExportButtonProps {
  onClick: () => void;
  disabled?: boolean;
  label?: string;
}

/** Outlined primary “Export CSV” used next to Clear filters / column visibility on TanStack tables. */
const TableCsvExportButton: React.FC<TableCsvExportButtonProps> = ({
  onClick,
  disabled = false,
  label = 'Export CSV',
}) => (
  <Button
    variant="outlined"
    size="small"
    startIcon={<FileDownloadOutlinedIcon sx={{ fontSize: 18 }} />}
    disabled={disabled}
    onClick={onClick}
    sx={{
      color: SEARCE_COLORS.primary,
      borderColor: SEARCE_COLORS.primary,
      flexShrink: 0,
      '&:hover': {
        backgroundColor: alpha(SEARCE_COLORS.primary, 0.1),
        borderColor: SEARCE_COLORS.primary,
      },
    }}
  >
    {label}
  </Button>
);

export default TableCsvExportButton;
